// import { ArrowDropDown } from '@material-ui/icons';
import { connect } from 'react-redux';
import { Menu, MenuItem } from '@material-ui/core';
import { onUserLogout } from 'Actions/loginActions';
import { withRouter } from 'react-router-dom';
import React from 'react';

import logo from 'Assets/icons/logo_v1.svg';

import Container from './components/Container';
import Logo from './components/Logo';
import LogoContainer from './components/LogoContainer';
import SettingsButton from './components/SettingsButton';
import SettingsContainer from './components/SettingsContainer';
import Drawer from './components/Drawer';
import HeaderMachine from './stateMachine';
import API from './api';
import AvatarUser from 'Avatar';
import { ArrowDropDown } from '@material-ui/icons';
import styled from 'styled-components';

const CustomArrowDown = styled(ArrowDropDown)`
  &&& {
    fill: ${({ theme }) => theme.palette.blue.light};
  }
  cursor: pointer;
`;

class Header extends React.PureComponent {
  state = {
    anchorEl: null,
    viewState: HeaderMachine.initialState.value,
    avatar: '',
    supProfile: null,
    error: '',
  };

  componentDidMount() {
    API.getUserProfile()
      .then(res => {
        this.setState({
          avatar: res.data.imageId,
          supProfile: res.data,
        });
      })
      .catch(err => {
        this.setState(state => ({
          error: err,
          viewState: HeaderMachine.transition(state.viewState, 'ERROR').value,
        }));
      });
  }

  onSettingsClick = e => {
    this.setState({
      anchorEl: e.currentTarget,
    });
  };

  onSettingsClose = () => {
    this.setState({ anchorEl: null });
  };

  redirectToDashboard = () => {
    this.props.history.push('/');
  };

  onEdit = type => e => {
    e.persist();
    this.setState(state => {
      if (type === 'profile') {
        return {
          anchorEl: e.currentTarget,
          viewState: HeaderMachine.transition(state.viewState, 'EDIT_PROFILE')
            .value,
        };
      }
      if (type === 'invite') {
        return {
          anchorEl: e.currentTarget,
          viewState: HeaderMachine.transition(state.viewState, 'INVITE').value,
        };
      }
      if (type === 'settings') {
        return {
          anchorEl: e.currentTarget,
          viewState: HeaderMachine.transition(state.viewState, 'SETTINGS')
            .value,
        };
      }
      return {
        anchorEl: e.currentTarget,
        viewState: HeaderMachine.transition(
          state.viewState,
          'EDIT_COMPANY_INFO'
        ).value,
      };
    });
  };

  onDrawerClose = () => {
    this.setState(state => {
      return {
        viewState: HeaderMachine.transition(state.viewState, 'CLOSE').value,
      };
    });
  };

  updateAvatarOnEdit = imageId => {
    this.setState({ avatar: imageId });
  };

  render() {
    const { anchorEl } = this.state;
    const { role } = this.props;
    return (
      <Container>
        <LogoContainer onClick={this.redirectToDashboard}>
          <Logo src={logo} />
        </LogoContainer>
        <SettingsContainer>
          {/* <SettingsButton
            data-testid="settingsButton"
            onClick={this.onSettingsClick}
            avatar={this.state.avatar}
          /> */}
          <AvatarUser
            user={this.state.supProfile}
            onClick={this.onSettingsClick}
            imageId={this.state.avatar}
          />
          <CustomArrowDown onClick={this.onSettingsClick} />

          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.onSettingsClose}
          >
            <MenuItem onClick={this.onEdit('profile')}>Edit profile</MenuItem>
            <MenuItem onClick={this.onEdit('company')}>
              {role[0] === 'ROLE_MANUFACTURER'
                ? 'Edit company info'
                : 'Edit product range'}
            </MenuItem>

            {role[0] === 'ROLE_MANUFACTURER' ? (
              <MenuItem onClick={this.onEdit('invite')}>
                Invite company users
              </MenuItem>
            ) : null}
            <MenuItem onClick={this.onEdit('settings')}>Settings</MenuItem>
            <MenuItem onClick={this.props.onUserLogout}>Logout</MenuItem>
          </Menu>
        </SettingsContainer>
        <Drawer
          onClose={this.onDrawerClose}
          open={
            this.state.viewState === 'edit_profile' ||
            this.state.viewState === 'invite' ||
            this.state.viewState === 'settings' ||
            this.state.viewState === 'edit_company_info'
              ? true
              : false
          }
          item={this.state.viewState}
          role={role}
          trigerUpdateAvatar={this.updateAvatarOnEdit}
        />
      </Container>
    );
  }
}

export default withRouter(
  connect(null, {
    onUserLogout,
  })(Header)
);
